import clsx from 'clsx';

export function TooltipArrowIcon({ className, ...props }) {
  return (
    <svg
      width="15"
      height="9"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className)}
      {...props}
    >
      <path
        d="M13.1433 5.94361e-05C14.0342 5.94361e-05 14.4804 1.0772 13.8504 1.70717L7.77937 7.77824C7.38885 8.16877 6.75568 8.16877 6.36516 7.77824L0.294097 1.70717C-0.335867 1.0772 0.1103 5.98575e-05 1.0012 5.98575e-05L13.1433 5.94361e-05Z"
        fill="currentColor"
      />
    </svg>
  );
}
